/** 列表/卡片展示用：优先推广正文，兼容旧数据 display_text */
export function mpEntryPreviewText(row: {
  promotion_text?: string | null;
  display_text?: string | null;
}): string {
  const raw = (row.promotion_text || row.display_text || '').replace(/\s+/g, ' ').trim();
  return raw;
}
